<template>
  <div class="container flex" style="padding-bottom: 20px;margin-top: 20px;">
    <testleft :list="list" :activeIndex="activeIndex" @tabIndex="tabIndex" @handleShowComputer="showcomputer=true"></testleft>
    <div style="flex:1;margin-left: 20px;">
      <testright @handleClose="showcomputer=false" :showcomputer="showcomputer" @quesitonList="showQuestion=true" :testQuestionsId="testQuestionsId" :questionsStatus="questionsStatus" :list="list" :status="status" @tabStatus="tabStatus" :activeIndex="activeIndex" @handlePrev="handlePrev" @handleNext="handleNext"></testright>
    </div>
    <template v-if="showQuestion">
      <question @closewin="showQuestion=false" :questionId="list[activeIndex].questionId"></question>
    </template>
  </div>
</template>

<script>
  document.onkeydown=function(e){


    if(e.code=='F5'){
      e.preventDefault()
    }

  }
  import testleft from './testleft'
  import testright from './testright'
  import question from './questionAnswering'
  export default {
    name: 'Footer',
    components:{
      testleft,
      testright,
      question
    },
    data () {
      return {
          data:'',
          pageNo:1,
          pageSize:10000,
          questionsStatus:this.$route.query.questionsStatus,
          testQuestionsId:this.$route.query.testQuestionsId,
          cacheCount:this.$route.query.cacheCount,
          status:-1,
          list:[],
          activeIndex:1,
          showcomputer:false,
          showQuestion:false
      }
    },
    methods:{
      handlePrev(){ //上一题
        this.activeIndex--
      },
      handleNext(){  //下一题
        this.activeIndex++
      },
      tabIndex(index){
        this.activeIndex=index;
      },
      getData(){
        let data={
          pageNo:this.pageNo,
          pageSize:this.pageSize,
          questionsStatus:this.questionsStatus,
          testQuestionsId:this.testQuestionsId,
          status:this.status
        };
        var url=this.$common.testPaper_testPaperQuestionList;
        						if(this.questionsStatus>2){

        								url=this.$common.testPaper_selectTestQuestionListByPageSize
        						}
        this.$axios.get(url,{params:data}).then((res)=>{
              if(res.data.code==1){
                  let list=res.data.data;
                  list.forEach((item,index)=>{
                    item.answerStatus=-1,
                    item.index=index+1

                  })
                  this.list=list;
              }
              else {
                alert(res.data.msg)
              }
        })
      },
      tabStatus(status){
        this.status=status;
        this.getData();
        this.activeIndex=1
      },
      getCache(){
        this.$axios.get(this.$common.testPaper_selectTestQuestionCache+'?testQuestionsId='+this.testQuestionsId).then((res)=>{
              if(res.data.code==1){
                  let list=JSON.parse(res.data.data.content);
                  list.forEach((item,index)=>{
                 //   item.answerStatus=-1,
                    item.index=index+1
                  })
                  for(var i=0;i<list.length;i++){

                        if(list[i].optionList.every((item)=>{return !item.selected})){
                          this.activeIndex=i+1;
                          console.log(this.activeIndex)
                      //    list[i].answerStatus=-1
                          break;
                        }
                  }
                  this.list=list;
              }
              else {
                alert(res.data.msg)
              }
        })
      }
    },
    created(){
      if(this.cacheCount==0){
        this.getData();
      }
      else {
        this.getCache();
      }


    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/homework.vue